import { create } from 'zustand';

interface NotificationsSlice {
  open: boolean;
  toggleNotificationPanel: () => void;
  openNotificationPanel: () => void;
  closeNotificationPanel: () => void;
}

const stateSlice = create<NotificationsSlice>()((set) => ({
  open: false,
  toggleNotificationPanel: () => set((state) => ({ open: !state.open })),
  openNotificationPanel: () => set({ open: true }),
  closeNotificationPanel: () => set({ open: false }),
}));

export default stateSlice;
